import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Teleport as _Teleport, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "kanban-blocks" }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-grey pa-4"
}
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_check_menu = _resolveComponent("ontos-check-menu")!
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_kanban_card = _resolveComponent("ontos-kanban-card")!
  const _component_ontos_kanban_block = _resolveComponent("ontos-kanban-block")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_instance_dialog = _resolveComponent("ontos-instance-dialog")!
  const _component_ontos_state_dialog = _resolveComponent("ontos-state-dialog")!
  const _component_ontos_delete_instance_dialog = _resolveComponent("ontos-delete-instance-dialog")!
  const _component_ontos_lane_value = _resolveComponent("ontos-lane-value")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!
  const _component_ontos_kanban_dimensions_dialog = _resolveComponent("ontos-kanban-dimensions-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    flush: _ctx.flush,
    ref: "base"
  }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(), _createBlock(_Teleport, {
              to: _ctx.headerTo || 'body',
              disabled: !_ctx.headerTo,
              defer: ""
            }, [
              _createVNode(_component_ontos_page_header, {
                title: _ctx.boardTitle,
                class: _normalizeClass({'board-header--elsewhere': !!_ctx.headerTo})
              }, _createSlots({
                actions: _withCtx(() => [
                  (_ctx.fieldMenuItems.length)
                    ? (_openBlock(), _createBlock(_component_ontos_check_menu, {
                        key: 0,
                        icon: "mdi-card-text-outline",
                        label: _ctx.$tt('card-fields'),
                        items: _ctx.fieldMenuItems,
                        "model-value": _ctx.selectedFields,
                        "onUpdate:modelValue": _ctx.onFieldsChange
                      }, null, 8, ["label", "items", "model-value", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.laneMenuItems.length)
                    ? (_openBlock(), _createBlock(_component_ontos_check_menu, {
                        key: 1,
                        icon: "mdi-view-week-outline",
                        label: _ctx.laneDimension.name,
                        items: _ctx.laneMenuItems,
                        "model-value": _ctx.visibleOf(_ctx.laneDimension),
                        min: 1,
                        "hover-color": "var(--ontos-kanban-highlight)",
                        "onUpdate:modelValue": _ctx.onLanesChange
                      }, null, 8, ["label", "items", "model-value", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.hiddenBlocks)
                    ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                        key: 2,
                        icon: _ctx.showEmptyBlocks ? 'mdi-eye-off-outline' : 'mdi-eye-outline',
                        label: _ctx.$tt('show-empty-blocks'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEmptyBlocks = !_ctx.showEmptyBlocks))
                      }, null, 8, ["icon", "label"]))
                    : _createCommentVNode("", true),
                  (_ctx.allDimensions.length > 1)
                    ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                        key: 3,
                        icon: "mdi-view-grid-outline",
                        label: _ctx.$tt('dimensions'),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dimensionsIsVisible = true))
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, [
                (_ctx.$slots.title)
                  ? {
                      name: "title",
                      fn: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                      ]),
                      key: "0"
                    }
                  : undefined,
                (_ctx.$slots.tabs)
                  ? {
                      name: "tabs",
                      fn: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "tabs", {}, undefined, true)
                      ]),
                      key: "1"
                    }
                  : undefined,
                (_ctx.$slots.controls)
                  ? {
                      name: "controls",
                      fn: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
                      ]),
                      key: "2"
                    }
                  : undefined,
                (_ctx.$slots.below)
                  ? {
                      name: "below",
                      fn: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "below", {}, undefined, true)
                      ]),
                      key: "3"
                    }
                  : undefined
              ]), 1032, ["title", "class"])
            ], 8, ["to", "disabled"])),
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleBlocks, (block) => {
                return (_openBlock(), _createBlock(_component_ontos_kanban_block, {
                  key: block.key,
                  lanes: block.lanes,
                  coordinate: block.coordinate,
                  labels: block.labels,
                  periods: _ctx.periods,
                  context: _ctx.context,
                  group: _ctx.dragGroup,
                  "moved-fields": _ctx.dimensions.map(dimension => dimension.key),
                  sliding: _ctx.sliding,
                  "can-create": _ctx.offersCreate || !!_ctx.addInLane,
                  "can-write": _ctx.can('editor'),
                  "create-label-of": _ctx.createLabelFor,
                  "count-title-of": _ctx.countTitle,
                  "slide-offset": _ctx.slideOffset,
                  onSlide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.slideOffset = $event)),
                  onCreate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCreate($event.coordinate, $event.lane, $event.element))),
                  onPeriodChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPeriodChange($event.lane, $event.period))),
                  onDragStart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dragOrigin = _ctx.originOf($event))),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCardDrop($event))),
                  onLink: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInstanceLink($event.event, $event.context)))
                }, {
                  default: _withCtx(({ instance, coordinate, lane }) => [
                    _createVNode(_component_ontos_kanban_card, {
                      class: "mb-2",
                      instance: instance,
                      title: _ctx.titleOf(instance),
                      fields: _ctx.cardFieldsOf(instance),
                      "state-option": _ctx.stateOptionOf(instance),
                      "can-write": _ctx.canEditItem(instance),
                      "can-edit": _ctx.canEditItem(instance),
                      "can-unlink": !!_ctx.unlinkItem,
                      "can-delete": _ctx.deletes && _ctx.canDeleteItem(instance),
                      onEdit: ($event: any) => (_ctx.editInstance($event, instance)),
                      onUnlink: ($event: any) => (_ctx.unlinkItem!(instance)),
                      onDelete: ($event: any) => (_ctx.deleting = instance),
                      context: _ctx.contextOf(instance),
                      "choice-domains": _ctx.workspace.domains,
                      href: _ctx.instanceHref(_ctx.contextOf(instance)),
                      "move-label": _ctx.$tt('value-change', {property: _ctx.laneDimension.name}),
                      onOpen: ($event: any) => (_ctx.onInstanceLink($event, _ctx.contextOf(instance))),
                      onPickState: ($event: any) => (_ctx.openPicker(instance, {...coordinate, [_ctx.laneDimension.key]: lane.id}))
                    }, null, 8, ["instance", "title", "fields", "state-option", "can-write", "can-edit", "can-unlink", "can-delete", "onEdit", "onUnlink", "onDelete", "context", "choice-domains", "href", "move-label", "onOpen", "onPickState"])
                  ]),
                  _: 1
                }, 8, ["lanes", "coordinate", "labels", "periods", "context", "group", "moved-fields", "sliding", "can-create", "can-write", "create-label-of", "count-title-of", "slide-offset"]))
              }), 128)),
              (_ctx.dimensions.length && !_ctx.visibleBlocks.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (!_ctx.instances.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$tt('instances-empty', {collection: _ctx.idea.pluralName})), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$tt('blocks-empty')) + " ", 1),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            size: "small",
                            color: "primary",
                            class: "text-none",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dimensionsIsVisible = true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$tt('dimensions')), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.createIsVisible)
              ? (_openBlock(), _createBlock(_component_ontos_instance_dialog, {
                  key: 0,
                  creating: _ctx.creating,
                  context: _ctx.context,
                  workspace: _ctx.workspace,
                  onCreated: _ctx.onCreated,
                  onDeleted: _cache[9] || (_cache[9] = ($event: any) => (_ctx.removeInstance($event))),
                  onShowMessage: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                  onShowErrorMessage: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('showErrorMessage', $event))),
                  onClosed: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeCreate()))
                }, null, 8, ["creating", "context", "workspace", "onCreated"]))
              : _createCommentVNode("", true),
            (_ctx.pickingFor)
              ? (_openBlock(), _createBlock(_component_ontos_state_dialog, {
                  key: 1,
                  heading: _ctx.pickerHeading,
                  field: _ctx.pickingDimension.name,
                  options: _ctx.pickingDimension.values,
                  form: _ctx.formOf(_ctx.pickingDimension),
                  current: _ctx.pickingDimension.valuesOf(_ctx.pickingFor),
                  multiple: !!_ctx.pickingDimension.multiple,
                  dimensions: _ctx.dimensionChoices,
                  dimension: _ctx.pickingDimension.key,
                  "onUpdate:dimension": _cache[13] || (_cache[13] = ($event: any) => (_ctx.pickingKey = $event)),
                  onPick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onPickState($event))),
                  onSave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSaveValues($event))),
                  onClosed: _cache[16] || (_cache[16] = ($event: any) => (_ctx.pickingFor = null))
                }, null, 8, ["heading", "field", "options", "form", "current", "multiple", "dimensions", "dimension"]))
              : _createCommentVNode("", true),
            (_ctx.deleting)
              ? (_openBlock(), _createBlock(_component_ontos_delete_instance_dialog, {
                  key: 2,
                  context: _ctx.contextOf(_ctx.deleting),
                  identifier: _ctx.deleting._identifier,
                  "idea-name": _ctx.idea.name,
                  onConfirmed: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onDeleteConfirmed())),
                  onOpenInstance: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openInstance($event))),
                  onClosed: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleting = null)),
                  onShowErrorMessage: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
                }, null, 8, ["context", "identifier", "idea-name"]))
              : _createCommentVNode("", true),
            (_ctx.asking)
              ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
                  key: 3,
                  title: _ctx.$tt('move-or-add'),
                  actions: _ctx.moveActions,
                  onPick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onHowToMove($event))),
                  onClosed: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onHowToMove(null)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$tt('move-or-add-question', _ctx.askingAbout)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.askingMoves, (move) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: move.dimension.key,
                        class: "d-flex align-center flex-wrap ga-2 my-3"
                      }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(move.dimension.name), 1),
                        _createVNode(_component_ontos_lane_value, {
                          value: move.from,
                          context: _ctx.context
                        }, null, 8, ["value", "context"]),
                        _createVNode(_component_v_icon, {
                          size: "small",
                          class: "text-medium-emphasis"
                        }, {
                          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                            _createTextVNode("mdi-arrow-right", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_ontos_lane_value, {
                          value: move.to,
                          context: _ctx.context
                        }, null, 8, ["value", "context"])
                      ]))
                    }), 128)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$tt('move-or-add-explain')), 1)
                  ]),
                  _: 1
                }, 8, ["title", "actions"]))
              : _createCommentVNode("", true),
            (_ctx.dimensionsIsVisible)
              ? (_openBlock(), _createBlock(_component_ontos_kanban_dimensions_dialog, {
                  key: 4,
                  idea: _ctx.idea,
                  dimensions: _ctx.allDimensions,
                  selected: _ctx.dimensions,
                  visible: _ctx.visible,
                  "items-of": _ctx.menuItemsOf,
                  onSave: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onDimensionsSave($event))),
                  onClosed: _cache[24] || (_cache[24] = ($event: any) => (_ctx.dimensionsIsVisible = false))
                }, null, 8, ["idea", "dimensions", "selected", "visible", "items-of"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["flush"]))
}